import React, { useState, useEffect } from "react";
import { getCurrentDate } from "../../Utilitie";
import { FaEraser, FaUpload } from "react-icons/fa";
import Loading from "../../Extra/Loading";
import { MdInsertChart } from "react-icons/md";
import { useGlobalContext } from "../../Context/GlobalContext";
import { Toast, ToastContainer } from "react-bootstrap";
import { IoIosCloudUpload } from "react-icons/io";
import SuccessMsg from "../../Extra/SuccessMsg";
import FailedMsg from "../../Extra/FailedMsg";
const InterchangeInsertion = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [result, setResult] = useState(null);
  const [allOk, setAllOk] = useState(true); ///add validation and condition
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const rows = 1;
  const cols = 29;
  const currentDate = getCurrentDate();
  const defaultValues = [[currentDate]]; // Define default values for the first two columns
  const [show, setShow] = useState(false);

  const columnHead = [
    `IC_DATE`,
    `WGN_TO`,
    `WGN_HO`,
    `WGN_TRSN`,
    `TRAIN_TO`,
    `TRAIN_HO`,
    `TRAIN_TRSN`,
    `T_FC`,
    `FC_FAIL`,
    `WTR`,
    `DWB`,
    `LDG`,
    `UNLDG`,
    `AVG_SPEED`,
    `SPEED_Exclud_Stable`,
    `SPEED_Includ_Stable`,
    `BCN_HOLDING`,
    `E_BCN_HOLDING`,
    `L_BCN_HOLDING`,
    `BOXN_HOLDING`,
    `E_BOXN_HOLDING`,
    `L_BOXN_HOLDING`,
    `LDD_RECD`,
    `EFF_DWB`,
    `SICK`,
    `ROH`,
    `POH`,
    `DEPT`,
    `TOTAL_INEF`,
  ];

  const [gridData, setGridData] = useState(
    Array(rows)
      .fill()
      .map((_, rowIndex) => [
        defaultValues[rowIndex][0], // Default first column (Read-Only)
        // defaultValues[rowIndex][1], // Default second column (Editable Date)
        ...Array(cols - 1).fill(""), // Empty values for other columns
      ])
  );

  const [messageDisplay, setMessageDisplay] = useState(false);

  const clearAll = () => {
    setGridData(
      Array(rows)
        .fill()
        .map((_, rowIndex) => [
          defaultValues[rowIndex][0], // Retain default first column
          // defaultValues[rowIndex][1], // Retain default second column
          ...Array(cols - 1).fill(""), // Clear other columns
        ])
    );
  };
  useEffect(() => {
    if (result?.message === "Data inserted successfully") {
      setMessageDisplay(true);
      clearAll();
    }

    const timer = setTimeout(() => {
      setMessageDisplay(false);
    }, 3000);

    return () => clearTimeout(timer); // Cleanup to prevent memory leaks
  }, [result]);
  const handleChange = (row, col, value) => {
    const newData = [...gridData];
    newData[row][col] = value;
    setGridData(newData);
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const clipboardData = e.clipboardData.getData("text");
    const rowsData = clipboardData.split("\n").map((row) => row.split("\t"));

    const newGridData = [...gridData];

    rowsData.forEach((row, rIndex) => {
      if (rIndex >= rows) return; // Prevent overflow

      row.forEach((cell, cIndex) => {
        if (cIndex >= cols - 1) return; // Prevent overflow
        newGridData[rIndex][cIndex + 1] = cell.trim(); // Paste from 2rd column
      });
    });

    setGridData(newGridData);
  };
  const sendToBackend = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${urlPrefix}insert/interchange`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(gridData),
      });
      const dataResult = await response.json();
      setResult(dataResult);
      setLoading(false);
      if (result.insertion) {
        clearAll();
      }
      setShow(true);
    } catch (error) {
      setLoading(false);
      setError(error);
      console.error("Error sending data:", error);
    }
  };

  return (
    <div
      className="container text-center mt-12"
      style={{ minHeight: "95vh", minWidth: "95vh" }}
    >
      <div className="papaDiv text-start">
        <h4>
          <MdInsertChart />
          Interchange
        </h4>
        <h5 className="ps-2">
          insert data in table <b style={{ color: "red" }}>"t_interchange"</b>
        </h5>
      </div>
      <div className="table-responsive">
        <table
          className="table table-striped table-hover "
          border="1"
          cellPadding="1"
          onPaste={handlePaste}
        >
          <thead>
            <tr className="table-dark" style={{ fontSize: "12px" }}>
              {columnHead.map((head, index) => {
                return <th style={{ border: "1px solid gray" }}>{head}</th>;
              })}
            </tr>
          </thead>

          <tbody className="">
            {gridData.map((row, rowIndex) => (
              <tr key={rowIndex} className="">
                {row.map((cell, colIndex) => (
                  <td key={colIndex} style={{ border: "1px solid gray" }}>
                    {colIndex === 0 ? (
                      <input
                        type="date"
                        value={cell}
                        style={{ width: "110px" }}
                        max={currentDate}
                        onChange={(e) =>
                          handleChange(rowIndex, colIndex, e.target.value)
                        }
                      />
                    ) : (
                      <input
                        type="text"
                        value={cell}
                        style={{ width: "60px" }}
                        onChange={(e) =>
                          handleChange(rowIndex, colIndex, e.target.value)
                        }
                      />
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div>
        <div className="p-3">
          {result && result?.insertion ? (
            <SuccessMsg
              head={"Success"}
              message={result?.message}
              show={show}
              setShow={setShow}
            />
          ) : (
            <FailedMsg
              head={"Failed"}
              message={`${result?.message} ,${result?.error}`}
              show={show}
              setShow={setShow}
            />
          )}
        </div>
      </div>
      <div>
        <button
          className=" m-1 btn btn-sm btn-outline-danger"
          onClick={clearAll}
        >
          <FaEraser /> Clear All
        </button>
        <button
          className={` m-1 btn btn-sm btn-outline-success ${
            !allOk ? "disabled" : null
          }`}
          onClick={sendToBackend}
        >
          <FaUpload /> Upload
        </button>
        {loading ? <Loading /> : null}
      </div>
    </div>
  );
};

export default InterchangeInsertion;
